import { useEffect } from 'react'

import { IconType } from '@factorialco/f0-react'
import { useAiChat } from '@factorialco/f0-react/dist/experimental'

interface UseAiChatAgentParams {
  agent: string
  initialMessage?: string
  welcomeScreenSuggestions?: {
    icon: IconType
    message: string
  }[]
}

export const useAiChatAgent = ({
  agent: targetAgent,
  initialMessage,
  welcomeScreenSuggestions,
}: UseAiChatAgentParams) => {
  const {
    tmp_setAgent,
    setInitialMessage,
    agent,
    clear,
    setWelcomeScreenSuggestions,
    setAutoClearMinutes,
  } = useAiChat()

  useEffect(() => {
    if (agent !== targetAgent) {
      tmp_setAgent(targetAgent)
      setInitialMessage(initialMessage)
      clear()
      setAutoClearMinutes(60 * 24) // 24 hours
      if (welcomeScreenSuggestions) {
        setWelcomeScreenSuggestions(welcomeScreenSuggestions)
      }
    }
  }, [])
}
